
// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'dark',
        themes: {
            dark: {
                dark: true,
                colors: {
                    background: '#1f2121', // --color-bg-primary
                    surface: '#262828',    // --color-bg-secondary
                    primary: '#3B82F6',    // Bright Blue
                    secondary: '#60A5FA',  // Lighter Blue
                    accent: '#93C5FD',     // Even lighter blue for accents
                    error: '#CF6679',
                    info: '#3B82F6',
                    success: '#3B82F6',
                    warning: '#FB8C00',
                    'on-background': '#f5f5f5',
                    'on-surface': '#f5f5f5',
                    'text-secondary': '#a7a9a9'
                },
                variables: {
                    'border-color': '#777c7c',
                    'border-opacity': 0.3,
                }
            }
        }
    }
})
